import { useEffect, useRef } from 'react';

export const useAfterPageLoad = (callback: () => void) => {
  const calledRef = useRef(false);

  useEffect(() => {
    const safeCall = () => {
      if (calledRef.current) return;
      calledRef.current = true;
      callback();
    };

    const onLoad = () => {
      safeCall();
    };

    const timeoutId = setTimeout(() => {
      safeCall();
    }, 5000);

    if (document.readyState === 'complete') {
      safeCall();
    } else {
      window.addEventListener('load', onLoad);
    }

    return () => {
      window.removeEventListener('load', onLoad);
      clearTimeout(timeoutId);
    };
  }, [callback]);
};

export const useAfterDOMReady = (callback: () => void) => {
  const calledRef = useRef(false);

  useEffect(() => {
    const safeCall = () => {
      if (calledRef.current) return;
      calledRef.current = true;
      callback();
    };

    const timeoutId = setTimeout(() => {
      safeCall();
    }, 5000);

    if (document.readyState !== 'loading') {
      safeCall();
    } else {
      document.addEventListener('DOMContentLoaded', safeCall);
    }

    return () => {
      document.removeEventListener('DOMContentLoaded', safeCall);
      clearTimeout(timeoutId);
    };
  }, [callback]);
};
